import React, { FC } from 'react';

import { NotFound } from 'components/not-found/NotFound';
import { Page } from 'components/page/Page';

const NotFoundPage: FC<{ message?: string }> = ({ message }) => (
    <Page hideFooter hideLicenseAgreement>
        <NotFound message={message} />
    </Page>
);

export default NotFoundPage;
